import React from 'react';
import { DateTime } from 'luxon';
import YellowTag from '../_base/YellowTag';

export default function ExpiredTag(props) {
  const { resource } = props;

  const diff = DateTime.now().diff(DateTime.fromISO(resource.data.endDate)).as('days');

  if (
    resource.data.completed ||
    resource.data.cancelled ||
    diff < 0
  ) {
    return null;
  }

  return (
    <YellowTag label="TIMEFRAME ENDED" />
  );
}
